import React from 'react'

const formatCpfCnpj = value => {
  if (value === undefined || value === null) return ''

  const raw = value.toString()
  const alnum = raw.replace(/[^0-9a-zA-Z]/g, '').toUpperCase()
  const digitsOnly = alnum.replace(/\D/g, '')

  // CPF: 11 dígitos numéricos
  if (digitsOnly.length === 11 && alnum.length === digitsOnly.length) {
    let v = digitsOnly

    if (v.length > 3) v = v.slice(0, 3) + '.' + v.slice(3)
    if (v.length > 7) v = v.slice(0, 7) + '.' + v.slice(7)
    if (v.length > 11) v = v.slice(0, 11) + '-' + v.slice(11)

    return v
  }

  // CNPJ: 12 primeiros = alfanumérico, 2 últimos = dígitos
  const head = alnum.slice(0, 12)
  const tailRaw = alnum.slice(12, 14)
  const tailDigits = tailRaw.replace(/\D/g, '').slice(0, 2)

  const cleaned = (head + tailDigits).slice(0, 14)

  let v = cleaned
  if (v.length > 2) v = v.slice(0, 2) + '.' + v.slice(2)
  if (v.length > 6) v = v.slice(0, 6) + '.' + v.slice(6)
  if (v.length > 10) v = v.slice(0, 10) + '/' + v.slice(10)
  if (v.length > 15) v = v.slice(0, 15) + '-' + v.slice(15)

  return v
}

export default function CnpjCpf({ children }) {
  return <span>{formatCpfCnpj(children)}</span>
}
